import { DJVehicleConditionQuestions } from "./types";

export const VEHICLE_CONDITION_TRANSLATION_KEYS = {
  haveAirbagsDeployed: "digital_journey_vehicle_condition.airbag_question",
  isVehicleDrivable: "digital_journey_vehicle_condition.vehicle_running_question",
  windshieldShattered: "vehicle_condition.windshield_shattered",
  canOpenAndCloseAllDoors: "vehicle_condition.can_open_and_close_all_doors",
} as const;

export const VEHICLE_CONDITION_QUESTION_DESCRIPTION_TRANSLATION_KEYS = {
  haveAirbagsDeployed: null,
  isVehicleDrivable: "digital_journey_vehicle_condition.vehicle_running_description",
  windshieldShattered: null,
  canOpenAndCloseAllDoors: null,
} as const;

export enum QuestionKeys {
  AirbagsDeployed = "airbags-deployed",
  IsDrivable = "is-drivable",
  WindshieldShattered = "windshield-shattered",
  CanOpenAndCloseAllDoors = "can-open-close-all-doors",
}

export const QuestionsKeyMap: Record<keyof DJVehicleConditionQuestions, QuestionKeys> = {
  haveAirbagsDeployed: QuestionKeys.AirbagsDeployed,
  isVehicleDrivable: QuestionKeys.IsDrivable,
  windshieldShattered: QuestionKeys.WindshieldShattered,
  canOpenAndCloseAllDoors: QuestionKeys.CanOpenAndCloseAllDoors,
};
